/**
 * Generate a migration-style timestamp prefix.
 * Example: "20260221143000"
 */
export function migrationTimestamp(): string {
    const now = new Date();
    const pad = (n: number, len = 2) => String(n).padStart(len, '0');
    return [
        now.getFullYear(),
        pad(now.getMonth() + 1),
        pad(now.getDate()),
        pad(now.getHours()),
        pad(now.getMinutes()),
        pad(now.getSeconds()),
    ].join('');
}

/**
 * Format a Date to ISO 8601 in UTC.
 */
export function toISOUTC(date: Date): string {
    return date.toISOString();
}

/**
 * Format an hour number (0–23) to a 12-hour label.
 * Example: 0 → "12 AM", 13 → "1 PM"
 */
export function hourLabel(hour: number): string {
    if (hour === 0) return '12 AM';
    if (hour < 12) return `${hour} AM`;
    if (hour === 12) return '12 PM';
    return `${hour - 12} PM`;
}
